import React from 'react';
import Layout from '../components/Layout';

import ScrollingText from '../components/lettersslider';
import ServiceComponent from '../components/servicedescrpition';
import ComponentWithCards from '../components/serviceheadings';
import OurService from '../components/servicepage/ourservice';
import ContactForm from '../components/servicecontact';




import LiteratureHeader from '../components/literatureheader';
import LiteratureServices from '../components/literatureservices';
import ManuscriptServices from '../components/manuscriptservices';
import ManuscriptHeader from '../components/manuscriptheader';
import useScrollTransition from '../useScrollTransition';


const ManuscriptPage = () => {
  useScrollTransition();
  return (
    <Layout>
      
        <ManuscriptHeader/>
        <ScrollingText/>
        <ManuscriptServices/>
        <ServiceComponent/>
      <ComponentWithCards/>
      <OurService/>
      <ContactForm/>
        
    </Layout>
  );
};

export default ManuscriptPage;